import React, { useState } from 'react';

export function AssetCard({ title, items, theme }) {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      style={{
        background: theme.cardBg,
        borderRadius: '12px',
        padding: '1.5rem',
        border: `1px solid ${isHovered ? theme.borderHover : theme.border}`,
        transition: 'all 0.3s',
        backdropFilter: 'blur(10px)',
        boxShadow: isHovered ? '0 10px 30px rgba(139, 0, 0, 0.15)' : 'none'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#D4AF37', marginBottom: '1.5rem' }}>
        {title}
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {items.map((item, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <span style={{ fontWeight: 500, color: theme.textPrimary }}>{item.name}</span>
              {item.code && <span style={{ fontSize: '0.75rem', color: theme.textSecondary, marginLeft: '0.5rem' }}>{item.code}</span>}
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontFamily: 'monospace', fontSize: '0.9rem', color: theme.textPrimary }}>{item.price}</div>
              <div style={{ fontSize: '0.75rem', fontWeight: 500, color: item.positive ? '#4ade80' : '#ef4444' }}>
                {item.change}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AssetCardWithTickers({ title, subtitle, tickers, marketData, theme }) {
  const [isHovered, setIsHovered] = useState(false);
  
  const getTickerData = (ticker) => {
    if (!marketData?.allTickers) return null;
    return marketData.allTickers.find(t => t.ticker === ticker);
  };
  
  return (
    <div 
      style={{
        background: theme.cardBg,
        borderRadius: '12px',
        padding: '1.5rem',
        border: `1px solid ${isHovered ? theme.borderHover : theme.border}`,
        transition: 'all 0.3s',
        backdropFilter: 'blur(10px)',
        boxShadow: isHovered ? '0 10px 30px rgba(139, 0, 0, 0.15)' : 'none'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#D4AF37', marginBottom: '0.25rem' }}>
        {title}
      </h3>
      <p style={{ fontSize: '0.7rem', color: theme.textSecondary, marginBottom: '1.5rem' }}>
        {subtitle}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {tickers.map((ticker, i) => {
          const data = getTickerData(ticker);
          if (!data) return null;
          return (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontWeight: 500, color: theme.textPrimary, fontSize: '0.85rem' }}>{ticker}</span>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontFamily: 'monospace', fontSize: '0.85rem', color: theme.textPrimary }}>
                  R$ {data.ult?.toFixed(2) || 'N/A'}
                </div>
                <div style={{ fontSize: '0.7rem', fontWeight: 500, color: data.var >= 0 ? '#4ade80' : '#ef4444' }}>
                  {data.var >= 0 ? '+' : ''}{data.var?.toFixed(2) || '0.00'}%
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}